export interface HousePlan {
    id: number;
    images: ImageElement[];
    product: Product;
    name: string;
    slug: string;
    plan_identifier: string;
    is_public: boolean;
    date_created: Date;
    description: string;
    house_type: HouseType;
    bedrooms: number;
    bathrooms: number;
    floor_area: number;
    plot_area: number;
    width: string;
    length: string;
    plan_price: string;
    cost: number;
    show_calculated_cost: boolean;
    ratings_score: number | null;
    minimum_plot_size: MinimumPlotSize | null;
    tags: Tag[] | null;
}

export enum HouseType {
    Bedsitter = "bedsitter",
    Bungalow = "bungalow",
    Jengapolepole = "jengapolepole",
    Maisonette = "maisonette",
    Module = "module",
    Mansion = "mansion",
}

export interface ImageElement {
    id: number;
    image: ImageImage;
    sort_order: number;
    building_plan: number;
}

export interface ImageImage {
    id: number;
    title: string;
    file: string;
    width: number;
    height: number;
    created_at: Date;
    focal_point_x: null;
    focal_point_y: null;
    focal_point_width: null;
    focal_point_height: null;
    file_size: number;
    file_hash: string;
    collection: number;
    uploaded_by_user: number | null;
}

export enum MinimumPlotSize {
    Empty = "",
    The30X60 = "30x60",
    The40X80 = "40x80",
    The50X100 = "50x100",
}

export interface Product {
    url: string;
    upc: string;
    id: number;
    title: string;
    description: string;
    structure: Structure;
    date_created: Date;
    date_updated: Date;
    recommended_products: any[];
    attributes: any[];
    categories: any[];
    product_class: ProductClass;
    images: any[];
    price: string;
    availability: string;
    stockrecords: string;
    options: any[];
    children: any[];
}

export enum ProductClass {
    BuildingPlans = "building-plans",
}

export enum Structure {
    Standalone = "standalone",
}

export enum Tag {
    Nachu = "NACHU",
}
